import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M4.60003 9.84247V9.49039L4.35107 9.24143L2.20467 7.09503C1.95083 6.84119 1.95083 6.42963 2.20467 6.17579L5.41335 2.96711C5.56837 2.81209 5.77862 2.725 5.99785 2.725C6.30452 2.725 6.6658 2.93168 7.13752 3.37466C7.87012 4.06261 8.89093 4.475 10.0001 4.475C11.1118 4.475 12.1349 4.06064 12.8679 3.36969C13.3351 2.92928 13.6936 2.725 13.9966 2.725C14.2136 2.725 14.4216 2.81118 14.575 2.96457L17.7862 6.17579C18.0401 6.42963 18.0401 6.84119 17.7862 7.09503L15.649 9.23227L15.4 9.48123V9.83331V16C15.4 16.359 15.109 16.65 14.75 16.65H5.25003C4.89105 16.65 4.60003 16.359 4.60003 16V9.84247Z", "stroke": "currentColor", "stroke-width": "1.7" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const SwitchThemeIcon = __component__.exports;
export {
  SwitchThemeIcon as default
};
